export const theme = {
  colors: {
    text: { primary: "#0f172a" },
    gradient: { from: "#38bdf8", to: "#6366f1" },
  },
  bp: { sm: 480, md: 768, lg: 1024, xl: 1280 }
};
